import queryString from 'query-string';
import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title } from 'common/components/layout';
import { validateResetPasswordId } from 'redux/customer/actions';

// import CreateAccountForm from 'profile/createAccount/CreateAccount';
import ResetPasswordForm from './forms/ResetPasswordForm';

class ResetPassword extends Component {
  componentDidMount() {
    const { props } = this;
    const { resetPasswordId } = props.match.params;
    const { emailId } = queryString.parse(props.location.search);
    const errorFunction = () => {
      props.history.push('/profile/reset-password-link-error');
    };
    props.validateResetPasswordId(resetPasswordId, emailId, errorFunction);
  }

  render() {
    const { props } = this;
    const { customer, settings } = this.props;
    const { resetPasswordId } = props.match.params;
    let { emailId } = queryString.parse(props.location.search);
    // Clean up any trailing slashes from 301 redirects
    if (emailId) {
      const emailResults = emailId.match(/([a-f\d-]+)/i);
      [emailId] = emailResults;
    }

    if (!settings.data) {
      return (
        <Layout title="Reset Password" loading>
          <Title>Reset Password</Title>
        </Layout>
      );
    }
    if (!customer) {
      return <div>Loading...</div>;
    }
    if (customer && !customer.firstName) {
      // return <CreateAccountForm resetPasswordId={resetPasswordId} />;
      return (
        <Layout title="Reset Password">
          <Title>Reset Password</Title>
          <ResetPasswordForm
            resetPasswordId={resetPasswordId}
            emailId={emailId}
          />
        </Layout>
      );
    }
    if (customer && customer.firstName) {
      return (
        <Layout title="Reset Password">
          <Title>Reset Password</Title>
          <ResetPasswordForm
            resetPasswordId={resetPasswordId}
            emailId={emailId}
          />
        </Layout>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer.data,
  settings: state.setting
});

export default connect(mapStateToProps, { validateResetPasswordId })(
  ResetPassword
);
